{
  "shcB": {
    "page": {
      "notFound": "Strona nie znaleziona"
    }
  }
}
